/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1UserSessionState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_USER_SESSION_STATE_ENTITY_NAME = 'ixm.userauth.v1.UserSession';
export const ixmUserauthV1UserSessionStateEntity = new schema.Entity<IxmUserauthV1UserSessionState>(IXM_USERAUTH_V1_USER_SESSION_STATE_ENTITY_NAME, {}, { idAttribute: 'sessionId' });

